import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ContestCommentPost from "./ContestCommentPost";
import ChildCommentListing from "./ChildCommentListing";
import PostNotFound from "../../../../../CustomComponents/AllLoader/PostNotFound";
import { useDispatch, useSelector } from "react-redux";
import { getContestPublicComment } from "../../../../../../redux/contest/action";
import getTimeDifference from "../../../../../Common/TimeDifference";
import ProfilePic from "../../../../../../assests/imgs/Profileplaceholder.svg";

export default function PublicComment({
  toggleCommentID,
  setViewCommentID,
  togglesetViewCommentID,
  commentid,
  viewcommentid,
  setCommentID,
  posts,
  size,
  setSize,
}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();
  const gcpcl = useSelector(
    ({ contest: { getcontestpubliccommentlist } }) =>
      getcontestpubliccommentlist,
  );
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    dispatch(getContestPublicComment(id, size));
  }, [dispatch, id, size]);

  const handleLoadMore = () => {
    setSize((prevSize) => prevSize + 5);
  };

  return (
    <div>
      {Array.isArray(gcpcl?.response) &&
        (gcpcl?.response?.length > 0 ? (
          <>
            {gcpcl?.response?.map((item, index) => (
              <div key={index} className="comment-sec1">
                <div className="comment-sec">
                  <img src={item?.profile_image ?item?.profile_image :ProfilePic} alt="" />
                  <div className="w-100">
                    <div className="profile-sec">
                      <h6>
                        {item?.first_name} {item?.last_name}
                      </h6>
                      <p>
                        {getTimeDifference(item?.created_on)}
                        <span
                          onClick={() => {
                            toggleCommentID(item?.id);
                          }}
                        >
                          Reply
                        </span>
                      </p>
                    </div>
                    <p>{item?.message}</p>
                  </div>
                </div>
                {item.id == commentid && (
                  <ContestCommentPost
                    posts={posts}
                    setViewCommentID={setViewCommentID}
                    item={item}
                    commentid={item?.id}
                    setCommentID={setCommentID}
                  />
                )}
                {item?.reply_count > 0 && (
                  <span
                    className="view-comment"
                    onClick={() => {
                      togglesetViewCommentID(item?.id);
                    }}
                  >
                    {viewcommentid == null ? <>View Reply</> : <>Hide Reply</>}
                  </span>
                )}
                {item.id == viewcommentid && (
                  <ChildCommentListing item={item} paramid={id} />
                )}
              </div>
            ))}
            {/* {gcpcl?.response?.length > 4 && <button className='btn load-more'>Load more</button>} */}
            {gcpcl?.count > gcpcl?.response?.length && (
              <button
                className="btn load-more"
                onClick={handleLoadMore}
                disabled={loading}
              >
                {loading ? "Loading..." : "View More Comments"}
              </button>
            )}
          </>
        ) : (
          <>
            <PostNotFound title={"No Public Comment Yet"} />
          </>
        ))}
    </div>
  );
}
